import _typeof from '@babel/runtime-corejs3/helpers/esm/typeof';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import { useEffect } from 'react';

var useEvent = function useEvent(name, handler, target, options) {
  var optionStringify = _JSON$stringify(options);
  useEffect(function () {
    var targetElement;
    if (target === undefined) {
      targetElement = window;
    } else if (target && _typeof(target) === 'object' && 'current' in target) {
      targetElement = target.current;
    } else {
      targetElement = target;
    }
    if (!handler || !targetElement) return undefined;
    var eventOptions = optionStringify ? JSON.parse(optionStringify) : undefined;
    targetElement.addEventListener(name, handler, eventOptions || {
      passive: true
    });
    return function () {
      if (targetElement) {
        targetElement.removeEventListener(name, handler, eventOptions);
      }
    };
  }, [name, handler, target, optionStringify]);
};

export { useEvent as default };
//# sourceMappingURL=useEvent.js.map
